import React from "react";

const ShoutOn = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9418 28.3352C0.555939 22.6136 1.50988 10.2726 8.90597 5.52456L7.28528 3C-1.84029 8.85835 -2.98715 23.8279 7.25099 30.8133L8.9418 28.3352ZM22.5928 24.5712C27.5773 21.3713 28.2201 13.0551 22.5689 9.19935L23.6961 7.54727C30.5822 12.2456 29.8107 22.3142 23.6732 26.2542L22.5928 24.5712ZM11.209 9.26525C6.22454 12.4652 5.58174 20.7813 11.2329 24.6371L10.1057 26.2892C3.21968 21.5909 3.99109 11.5223 10.1286 7.58221L11.209 9.26525ZM24.8959 28.3119C32.292 23.5638 33.2459 11.2229 24.86 5.50129L26.5508 3.02316C36.789 10.0086 35.6421 24.9781 26.5166 30.8365L24.8959 28.3119ZM18.1269 17.104C17.8335 17.2 17.4895 17.248 17.0949 17.248H15.4869V13.096H17.0949C17.4949 13.096 17.8415 13.144 18.1349 13.24C18.4282 13.3307 18.6709 13.464 18.8629 13.64C19.0549 13.816 19.1989 14.0294 19.2949 14.28C19.3909 14.5307 19.4389 14.8107 19.4389 15.12C19.4389 15.4454 19.3909 15.7414 19.2949 16.008C19.1989 16.2694 19.0522 16.4934 18.8549 16.68C18.6629 16.8614 18.4202 17.0027 18.1269 17.104ZM19.1029 11.704C18.5375 11.5227 17.8682 11.432 17.0949 11.432H13.3349V23H15.4869V18.928H17.0949C17.8469 18.928 18.5029 18.8347 19.0629 18.648C19.6282 18.4614 20.0975 18.2 20.4709 17.864C20.8442 17.528 21.1242 17.128 21.3109 16.664C21.4975 16.1947 21.5909 15.68 21.5909 15.12C21.5909 14.5814 21.5002 14.0854 21.3189 13.632C21.1429 13.1787 20.8709 12.7894 20.5029 12.464C20.1349 12.1387 19.6682 11.8854 19.1029 11.704Z"
        fill="#00a799"
      />
    </svg>
  );
};

export default ShoutOn;
